// @flow
import * as React from 'react';
import isEqual from 'react-fast-compare';
import notificationPermissions from '../../../enums/notificationPermissions';

type Props = {|
    getBrowserPermission: Function,
    notifications: any[],
    permission: string,
    setPermission: Function,
    showNotifications: boolean,
|};

type State = {|
    ignored: boolean,
    shownInitialNotification: boolean,
    shownNotifications: string[],
    supported: boolean,
|};

export default class PushNotificationsContainer extends React.Component<Props, State> {
    static defaultProps = {
        notifications: [],
        permission: '',
        showNotifications: true,
    };

    state = {
        ignored: false,
        shownInitialNotification: false,
        shownNotifications: [],
        supported: true,
    };

    componentDidMount() {
        this.props.getBrowserPermission();
    }

    shouldComponentUpdate = (nextProps: Props, nextState: State) =>
        !isEqual(this.props, nextProps) || !isEqual(this.state, nextState);

    componentDidUpdate() {
        if (this.props.permission === notificationPermissions.GRANTED) {
            this.props.notifications.forEach(notification => {
                if (
                    notification &&
                    notification.id &&
                    notification.message &&
                    !this.state.shownNotifications.includes(notification.id)
                ) {
                    this.showNotification(notification);
                }
            });
        }
    }

    showNotification = (n: any) => {
        this.setState({ shownNotifications: [...this.state.shownNotifications, n.id] });
        const notification = new Notification(n.title, {
            badge: n.imageUrl,
            body: n.message,
            icon: n.imageUrl,
            image: n.imageUrl,
            tag: n.id,
        });
        notification.onclick = event => {
            event.preventDefault();
            window.open(n.link, '_blank');
        };
    };

    render() {
        return null;
    }
}
